export default ({ instanceProcon }) => {
	return {
		importarDocumento(val, arquivo) {
			const parametros = new URLSearchParams({
				cliente_id: val.clienteId,
				procon_id: val.proconId,
			}).toString();

			const basicAuth =
				"Basic " +
				btoa(
					`${process.env.VUE_APP_USER_PROCON_API}:${process.env.VUE_APP_PASSWORD_PROCON_API}`
				);

			return instanceProcon({
				method: "post",
				url: "importar_documento?" + parametros,
				data: arquivo,
				headers: {
					Authorization: basicAuth,
				},
			});
		},

		cadastrarCredencial(data) {
			const basicAuth =
				"Basic " +
				btoa(
					`${process.env.VUE_APP_USER_PROCON_API}:${process.env.VUE_APP_PASSWORD_PROCON_API}`
				);

			return instanceProcon({
				method: "post",
				url: "inserir_credencial",
				data: data,
				headers: {
					Authorization: basicAuth,
				},
			});
		},

		deletarCredencial(data) {
			const basicAuth =
				"Basic " +
				btoa(
					`${process.env.VUE_APP_USER_PROCON_API}:${process.env.VUE_APP_PASSWORD_PROCON_API}`
				);

			return instanceProcon({
				method: "delete",
				url: "deletar_credenciais",
				data: data,
				headers: {
					Authorization: basicAuth,
				},
			});
		},

		consultarCertificado(val) {
			const parametros = new URLSearchParams({
				identificador: val,
			}).toString();

			return instanceProcon({
				method: "post",
				url: "procon/visualizar_documento?" + parametros,
			});
		},
	};
};
